import { toDecimalString } from "../../../../../shared/utils/numbers";

const formaterNumberCell = (value,precision) => value < 0 ? `(${toDecimalString(value*-1,precision)})` : (value>0 ? toDecimalString(value,precision) : '-');
const mayorCien = (value) => value > 0 ? '>100' : '(>100)';

export const subTitlesTableTendVeh = [
    {label:'', colIni:0, colFin:1},
    {label:'SUCURSAL', colIni:2, colFin:10, tipo: 'suc'},
    {label:'', colIni:11, colFin:11, tipo: 'suc'},
    {label:'FILIAL', colIni:12, colFin:20, tipo: 'fil'},
    {label:'', colIni:21, colFin:21, tipo: 'fil'},
    {label:'UTE_EXTRANJERA', colIni:22, colFin:30, tipo: 'ute'},
    {label:'', colIni:31, colFin:31, tipo: 'ute'},
    {label:'ELECNOR_MATRIZ', colIni:32, colFin:40, tipo: 'elec'},
    {label:'', colIni:41, colFin:41, tipo: 'elec'},
    {label:'TOTAL', colIni:42, colFin:50}
]

export const columnsTableTendVeh = [
    {
      field: 'idCentro',
      name: 'Centro ooo',
      sortable: true,
      'data-test-subj': 'centro fixed',
      render: (data) =>{
        return (
            <span>{ ((data.idPais!=='@@' && data.idPais!=='A@') ? (data.idPais==='00' ? `NACIONAL` : `INTERNACIONAL`) : `${data.idCentro} - ${data.centro}`)}</span>
      )},
      width:'400px'
    },
    {
        name: '',
        'data-test-subj': 'spaceCell fixedSpace',
        render: () => null,
        width:'5px'
    },
    {
        field: 'facT_SUC',
        name: 'FACT',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.facT_SUC,0)}</span>),
        width:'110px',
        tipo: 'suc'
    },
    {
        field: 'proD_SUC',
        name: 'PROD',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.proD_SUC,0)}</span>),
        width:'110px',
        tipo: 'suc'
    },
    {
        field: 'apoR_BRUTO_SUC',
        name: 'APOR BRUTA',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apoR_BRUTO_SUC,0)}</span>),
        width:'110px',
        tipo: 'suc'
    },
    {
        field: 'fra_Servicios_SUC',
        name: 'FRA. SERVICIOS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.fra_Servicios_SUC,0)}</span>),
        width:'110px',
        tipo: 'suc'
    },
    {
        field: 'apoR_SUC',
        name: 'APOR',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apoR_SUC,0)}</span>),
        width:'110px',
        tipo: 'suc'
    },
    {
        field: 'margen_SUC',
        name: '%MARGEN',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.margen_SUC)>100 ? mayorCien(data.margen_SUC)  : formaterNumberCell(data.margen_SUC,1)}</span>),
        width:'100px',
        tipo: 'suc'
    },
    // {
    //     field: 'baI_SUC',
    //     name: 'BAI FISCAL',
    //     sortable: false,
    //     dataType: 'number',
    //     render: (data) => (<span>{formaterNumberCell(data.baI_SUC,0)}</span>),
    //     width:'110px'
    // },
    {
        field: 'tasA_IS_SUC',
        name: 'TIPO IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.tasA_IS_SUC,1)}</span>),
        width:'100px',
        tipo: 'suc'
    },
    {
        field: 'impsoC_SUC',
        name: 'IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.impsoC_SUC,0)}</span>),
        width:'110px',
        tipo: 'suc'
    },
    {
        field: 'bdI_SUC',
        name: 'BDI',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.bdI_SUC,0)}</span>),
        width:'110px',
        tipo: 'suc'
    },
//11

    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px',
        tipo: 'suc'
    },


    {
        field: 'facT_FIL',
        name: 'FACT',
        sortable: false,
        'data-test-subj': 'firstNameCell',
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.facT_FIL,0)}</span>),
        width:'110px',
        tipo: 'fil'
    },
    {
        field: 'proD_FIL',
        name: 'PROD',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.proD_FIL,0)}</span>),
        width:'110px',
        tipo: 'fil'
    },
    {
        field: 'apoR_BRUTO_FIL',
        name: 'APOR BRUTA',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apoR_BRUTO_FIL,0)}</span>),
        width:'110px',
        tipo: 'fil'
    },
    {
        field: 'fra_Servicios_FIL',
        name: 'FRA. SERVICIOS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.fra_Servicios_FIL,0)}</span>),
        width:'110px',
        tipo: 'fil'
    },
    {
        field: 'apoR_FIL',
        name: 'APOR',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apoR_FIL,0)}</span>),
        width:'110px',
        tipo: 'fil'
    },
    {
        field: 'margen_FIL',
        name: '%MARGEN',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.margen_FIL)>100 ? mayorCien(data.margen_FIL) : formaterNumberCell(data.margen_FIL,1)}</span>),
        width:'100px',
        tipo: 'fil'
    },
    {
        field: 'tasA_IS_FIL',
        name: 'TIPO IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.tasA_IS_FIL,1)}</span>),
        width:'100px',
        tipo: 'fil'
    },
    {
        field: 'impsoC_FIL',
        name: 'IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.impsoC_FIL,0)}</span>),
        width:'110px',
        tipo: 'fil'
    },
    {
        field: 'bdI_FIL',
        name: 'BDI',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.bdI_FIL,0)}</span>),
        width:'110px',
        tipo: 'fil'
    },
//19
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px',
        tipo: 'fil'
    },

    {
        field: 'facT_UTE',
        name: 'FACT',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.facT_UTE,0)}</span>),
        width:'110px',
        tipo: 'ute'
    },
    {
        field: 'proD_UTE',
        name: 'PROD',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.proD_UTE,0)}</span>),
        width:'110px',
        tipo: 'ute'
    },
    {
        field: 'apoR_BRUTO_UTE',
        name: 'APOR BRUTA',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apoR_BRUTO_UTE,0)}</span>),
        width:'110px',
        tipo: 'ute'
    },
    {
        field: 'fra_Servicios_UTE',
        name: 'FRA. SERVICIOS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.fra_Servicios_UTE,0)}</span>),
        width:'110px',
        tipo: 'ute'
    },
    {
        field: 'apoR_UTE',
        name: 'APOR',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apoR_UTE,0)}</span>),
        width:'110px',
        tipo: 'ute'
    },
    {
        field: 'margen_UTE',
        name: '%MARGEN',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.margen_UTE)>100 ? mayorCien(data.margen_UTE) : formaterNumberCell(data.margen_UTE,1)}</span>),
        width:'100px',
        tipo: 'ute'
    },
    {
        field: 'tasA_IS_UTE',
        name: 'TIPO IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.tasA_IS_UTE,1)}</span>),
        width:'100px',
        tipo: 'ute'
    },
    {
        field: 'impsoC_UTE',
        name: 'IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.impsoC_UTE,0)}</span>),
        width:'110px',
        tipo: 'ute'
    },
    {
        field: 'bdI_UTE',
        name: 'BDI',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.bdI_UTE,0)}</span>),
        width:'110px',
        tipo: 'ute'
    },
//27
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px',
        tipo: 'ute'
    },

    {
        field: 'facT_ELEC',
        name: 'FACT',
        sortable: false,
        'data-test-subj': 'firstNameCell',
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.facT_ELEC,0)}</span>),
        width:'110px',
        tipo: 'elec'
    },
    {
        field: 'proD_ELEC',
        name: 'PROD',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.proD_ELEC,0)}</span>),
        width:'110px',
        tipo: 'elec'
    },
    {
        field: 'apoR_BRUTO_ELEC',
        name: 'APOR BRUTA',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apoR_BRUTO_ELEC,0)}</span>),
        width:'110px',
        tipo: 'elec'
    },
    {
        field: 'fra_Servicios_ELEC',
        name: 'FRA. SERVICIOS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.fra_Servicios_ELEC,0)}</span>),
        width:'110px',
        tipo: 'elec'
    },
    {
        field: 'apoR_ELEC',
        name: 'APOR',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apoR_ELEC,0)}</span>),
        width:'110px',
        tipo: 'elec'
    },
    {
        field: 'margen_ELEC',
        name: '%MARGEN',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.margen_ELEC)>100 ? mayorCien(data.margen_ELEC) : formaterNumberCell(data.margen_ELEC,1)}</span>),
        width:'100px',
        tipo: 'elec'
    },
    // {
    //     field: 'baI_ELEC',
    //     name: 'BAI FISCAL',
    //     sortable: false,
    //     dataType: 'number',
    //     render: (data) => (<span>{formaterNumberCell(data.baI_ELEC,0)}</span>),
    //     width:'110px'
    // },
    {
        field: 'tasA_IS_ELEC',
        name: 'TIPO IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.tasA_IS_ELEC,1)}</span>),
        width:'100px',
        tipo: 'elec'
    },
    {
        field: 'impsoC_ELEC',
        name: 'IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.impsoC_ELEC,0)}</span>),
        width:'110px',
        tipo: 'elec'
    },
    {
        field: 'bdI_ELEC',
        name: 'BDI',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.bdI_ELEC,0)}</span>),
        width:'110px',
        tipo: 'elec'
    },
//38
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px',
        tipo: 'elec'
    },

    {
        field: 'fact',
        name: 'FACT',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.fact,0)}</span>),
        width:'110px'
    },
    {
        field: 'prod',
        name: 'PROD',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.prod,0)}</span>),
        width:'110px'
    },
    {
        field: 'apoR_BRUTO',
        name: 'APOR BRUTA',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apoR_BRUTO,0)}</span>),
        width:'110px'
    },
    {
        field: 'fra_Servicios',
        name: 'FRA. SERVICIOS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.fra_Servicios,0)}</span>),
        width:'110px'
    },
    {
        field: 'apor',
        name: 'APOR',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apor,0)}</span>),
        width:'110px'
    },
    {
        field: 'margen',
        name: '%MARGEN',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.margen)>100 ? mayorCien(data.margen) : formaterNumberCell(data.margen,1)}</span>),
        width:'100px'
    },
    {
        field: 'tasA_IS',
        name: 'TIPO IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.tasA_IS,1)}</span>),
        width:'100px'
    },
    {
        field: 'impsoc',
        name: 'IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.impsoc,0)}</span>),
        width:'110px'
    },
    {
        field: 'bdi',
        name: 'BDI',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.bdi,0)}</span>),
        width:'110px'
    }

  ];